import type { ChainId } from '$lib/models'

export type ChainConfig = {
	id: ChainId
	slug: string
	name: string
	token?: string
	soon?: boolean
	listed?: Date
}

/* eslint sort-keys: ["error", "asc", { caseSensitive: true, natural: true }] */
export const CHAINS_CONFIG: Record<ChainId, ChainConfig> = {
	acala_chain: {
		id: 'acala_chain',
		name: 'Acala',
		slug: 'acala',
		soon: true,
		token: 'ACA',
	},
	aelf_chain: {
		id: 'aelf_chain',
		name: 'aelf',
		slug: 'aelf',
		soon: true,
		token: 'ELF',
	},
	aeternity_chain: {
		id: 'aeternity_chain',
		listed: new Date('2024-05-03T00:00:00Z'),
		name: 'Aeternity',
		slug: 'aeternity',
		token: 'AE',
	},
	airdao_chain: {
		id: 'airdao_chain',
		listed: new Date('2024-04-07T00:00:00Z'),
		name: 'AirDAO',
		slug: 'airdao',
		token: 'AMB',
	},
	ajuna_chain: {
		id: 'ajuna_chain',
		name: 'Ajuna Network',
		slug: 'ajuna',
		soon: true,
		token: 'AJUN',
	},
	aleph_zero_chain: {
		id: 'aleph_zero_chain',
		name: 'Aleph Zero',
		slug: 'aleph-zero',
		soon: true,
		token: 'AZERO',
	},
	alephium_chain: {
		id: 'alephium_chain',
		name: 'Alephium',
		slug: 'alephium',
		soon: true,
		token: 'ALPH',
	},
	algorand_chain: {
		id: 'algorand_chain',
		name: 'Algorand',
		slug: 'algorand',
		token: 'ALGO',
	},
	aptos_chain: {
		id: 'aptos_chain',
		listed: new Date('2024-05-27T00:00:00Z'),
		name: 'Aptos',
		slug: 'aptos',
		token: 'APT',
	},
	arbitrum_chain: {
		id: 'arbitrum_chain',
		name: 'Arbitrum',
		slug: 'arbitrum',
		token: 'ARB',
	},
	areon_chain: {
		id: 'areon_chain',
		name: 'Areon',
		slug: 'areon',
		soon: true,
		token: 'AREA',
	},
	arthera_chain: {
		id: 'arthera_chain',
		listed: new Date('2024-04-07T00:00:00Z'),
		name: 'Arthera',
		slug: 'arthera',
		token: 'ARTHERA',
	},
	astar_chain: {
		id: 'astar_chain',
		name: 'Astar',
		slug: 'astar',
		soon: true,
		token: 'ASTR',
	},
	aura_chain: {
		id: 'aura_chain',
		name: 'Aura',
		slug: 'aura',
		soon: true,
		token: 'AURA',
	},
	aurora_chain: {
		id: 'aurora_chain',
		name: 'Aurora',
		slug: 'aurora',
		soon: true,
		token: 'AURORA',
	},
	autonomys_chain: {
		id: 'autonomys_chain',
		name: 'Autonomys',
		slug: 'autonomys',
		soon: true,
	},
	avalanche_chain: {
		id: 'avalanche_chain',
		name: 'Avalanche',
		slug: 'avalanche',
		token: 'AVAX',
	},
	base_chain: {
		id: 'base_chain',
		name: 'Base',
		slug: 'base',
	},
	berachain_chain: {
		id: 'berachain_chain',
		name: 'Berachain',
		slug: 'berachain',
		soon: true,
		token: 'BERA',
	},
	bifrost_chain: {
		id: 'bifrost_chain',
		name: 'Bifrost',
		slug: 'bifrost',
		soon: true,
		token: 'BNC',
	},
	bitcoin_chain: {
		id: 'bitcoin_chain',
		name: 'Bitcoin',
		slug: 'bitcoin',
		token: 'BTC',
	},
	bitgert_chain: {
		id: 'bitgert_chain',
		name: 'Bitgert',
		slug: 'bitgert',
		soon: true,
		token: 'BRISE',
	},
	blast_chain: {
		id: 'blast_chain',
		name: 'Blast',
		slug: 'blast',
		soon: true,
		token: 'BLAST',
	},
	blockdag_chain: {
		id: 'blockdag_chain',
		name: 'BlockDAG',
		slug: 'blockdag',
		soon: true,
		token: 'BDAG',
	},
	bnb_chain: {
		id: 'bnb_chain',
		name: 'BNB Chain',
		slug: 'bnb-chain',
		token: 'BNB',
	},
	bnb_greenfield_chain: {
		id: 'bnb_greenfield_chain',
		name: 'BNB Greenfield',
		slug: 'bnb-greenfield',
	},
	bsv_chain: {
		id: 'bsv_chain',
		name: 'BSV Blockchain',
		slug: 'bsv',
		soon: true,
	},
	cardano_chain: {
		id: 'cardano_chain',
		name: 'Cardano',
		slug: 'cardano',
		token: 'ADA',
	},
	celestia_chain: {
		id: 'celestia_chain',
		name: 'Celestia',
		slug: 'celestia',
		soon: true,
		token: 'TIA',
	},
	celo_chain: {
		id: 'celo_chain',
		name: 'Celo',
		slug: 'celo',
		token: 'CELO',
	},
	chainlink_chain: {
		id: 'chainlink_chain',
		name: 'Chainlink',
		slug: 'chainlink',
		soon: true,
		token: 'LINK',
	},
	chromia_chain: {
		id: 'chromia_chain',
		name: 'Chromia',
		slug: 'chromia',
		soon: true,
		token: 'CHR',
	},
	concordium_chain: {
		id: 'concordium_chain',
		name: 'Concordium',
		slug: 'concordium',
		token: 'CCD',
	},
	core_chain: {
		id: 'core_chain',
		name: 'Core',
		slug: 'core',
		soon: true,
		token: 'CORE',
	},
	cosmos_chain: {
		id: 'cosmos_chain',
		name: 'Cosmos',
		slug: 'cosmos',
		soon: true,
		token: 'ATOM',
	},
	cronos_chain: {
		id: 'cronos_chain',
		name: 'Cronos',
		slug: 'cronos',
		token: 'CRO',
	},
	crust_chain: {
		id: 'crust_chain',
		name: 'Crust',
		slug: 'crust',
		token: 'CRU',
	},
	ecash_chain: {
		id: 'ecash_chain',
		listed: new Date('2024-03-28T00:00:00Z'),
		name: 'eCash',
		slug: 'ecash',
		token: 'XEC',
	},
	electra_protocol_chain: {
		id: 'electra_protocol_chain',
		name: 'Electra Protocol',
		slug: 'electra-protocol',
		soon: true,
		token: 'XEP',
	},
	electroneum_chain: {
		id: 'electroneum_chain',
		name: 'Electroneum',
		slug: 'electroneum',
		token: 'ETN',
	},
	eos_chain: {
		id: 'eos_chain',
		name: 'EOS Network',
		slug: 'eos',
		soon: true,
		token: 'EOS',
	},
	ethereum_chain: {
		id: 'ethereum_chain',
		name: 'Ethereum',
		slug: 'ethereum',
		token: 'ETH',
	},
	etherlink_chain: {
		id: 'etherlink_chain',
		name: 'Etherlink',
		slug: 'etherlink',
		soon: true,
	},
	fantom_chain: {
		id: 'fantom_chain',
		name: 'Fantom',
		slug: 'fantom',
		token: 'FTM',
	},
	flow_chain: {
		id: 'flow_chain',
		listed: new Date('2024-11-26T00:00:00Z'),
		name: 'Flow',
		slug: 'flow',
		token: 'FLOW',
	},
	fogo_chain: {
		id: 'fogo_chain',
		name: 'Fogo',
		slug: 'fogo',
		soon: true,
	},
	frequency_chain: {
		id: 'frequency_chain',
		name: 'Frequency',
		slug: 'frequency',
		soon: true,
	},
	gnosis_chain: {
		id: 'gnosis_chain',
		name: 'Gnosis Chain',
		slug: 'gnosis',
		token: 'GNO',
	},
	gravity_chain: {
		id: 'gravity_chain',
		listed: new Date('2025-04-08T00:00:00Z'),
		name: 'Gravity Alpha Mainnet',
		slug: 'gravity',
		token: 'G',
	},
	haven1_chain: {
		id: 'haven1_chain',
		name: 'Haven1',
		slug: 'haven1',
		soon: true,
		token: 'H1',
	},
	hedera_chain: {
		id: 'hedera_chain',
		name: 'Hedera',
		slug: 'hedera',
		token: 'HBAR',
	},
	hive_chain: {
		id: 'hive_chain',
		name: 'Hive',
		slug: 'hive',
		soon: true,
		token: 'HIVE',
	},
	hydration_chain: {
		id: 'hydration_chain',
		name: 'Hydration',
		slug: 'hydration',
		soon: true,
		token: 'HDX',
	},
	hyperliquid_chain: {
		id: 'hyperliquid_chain',
		name: 'Hyperliquid',
		slug: 'hyperliquid',
		soon: true,
		token: 'HYPER',
	},
	icp_chain: {
		id: 'icp_chain',
		name: 'ICP',
		slug: 'icp',
		token: 'ICP',
	},
	integritee_chain: {
		id: 'integritee_chain',
		name: 'Integritee',
		slug: 'integritee',
		token: 'TEER',
	},
	iota_chain: {
		id: 'iota_chain',
		name: 'IOTA',
		slug: 'iota',
		soon: true,
		token: 'IOTA',
	},
	iotex_chain: {
		id: 'iotex_chain',
		name: 'IoTeX',
		slug: 'iotex',
		token: 'IOTX',
	},
	kaspa_chain: {
		id: 'kaspa_chain',
		name: 'Kaspa',
		slug: 'kaspa',
		soon: true,
		token: 'KAS',
	},
	kava_chain: {
		id: 'kava_chain',
		name: 'Kava',
		slug: 'kava',
		soon: true,
		token: 'KAVA',
	},
	keeta_chain: {
		id: 'keeta_chain',
		name: 'Keeta',
		slug: 'keeta',
		soon: true,
		token: 'KTA',
	},
	klaytn_chain: {
		id: 'klaytn_chain',
		name: 'Kaia',
		slug: 'kaia',
		token: 'KLAY',
	},
	klever_chain: {
		id: 'klever_chain',
		name: 'Klever',
		slug: 'klever',
		soon: true,
		token: 'KLV',
	},
	kusama_chain: {
		id: 'kusama_chain',
		name: 'Kusama',
		slug: 'kusama',
		soon: true,
		token: 'KSM',
	},
	linea_chain: {
		id: 'linea_chain',
		name: 'Linea',
		slug: 'linea',
		soon: true,
	},
	litentry_chain: {
		id: 'litentry_chain',
		name: 'Litentry',
		slug: 'litentry',
		soon: true,
		token: 'LIT',
	},
	mantle_chain: {
		id: 'mantle_chain',
		name: 'Mantle',
		slug: 'mantle',
		soon: true,
		token: 'MNT',
	},
	massa_chain: {
		id: 'massa_chain',
		name: 'Massa',
		slug: 'massa',
		soon: true,
		token: 'MAS',
	},
	mazze_chain: {
		id: 'mazze_chain',
		name: 'Mazze',
		slug: 'mazze',
		soon: true,
		token: 'MAZZE',
	},
	megaeth_chain: {
		id: 'megaeth_chain',
		name: 'MegaETH',
		slug: 'megaeth',
		soon: true,
	},
	monad_chain: {
		id: 'monad_chain',
		name: 'Monad',
		slug: 'monad',
		soon: true,
	},
	moonbeam_chain: {
		id: 'moonbeam_chain',
		listed: new Date('2024-03-27T00:00:00Z'),
		name: 'Moonbeam',
		slug: 'moonbeam',
		token: 'GLMR',
	},
	multiversx_chain: {
		id: 'multiversx_chain',
		name: 'MultiversX',
		slug: 'multiversx',
	},
	mythos_chain: {
		id: 'mythos_chain',
		name: 'Mythos',
		slug: 'mythos',
		soon: true,
		token: 'MYTH',
	},
	near_chain: {
		id: 'near_chain',
		name: 'NEAR',
		slug: 'near',
		token: 'NEAR',
	},
	neuroweb_chain: {
		id: 'neuroweb_chain',
		name: 'NeuroWeb',
		slug: 'neuroweb',
		soon: true,
		token: 'NEURO',
	},
	nexa_chain: {
		id: 'nexa_chain',
		name: 'Nexa',
		slug: 'nexa',
		soon: true,
		token: 'NEXA',
	},
	opbnb_chain: {
		id: 'opbnb_chain',
		name: 'opBNB',
		slug: 'opbnb',
	},
	optimism_chain: {
		id: 'optimism_chain',
		name: 'Optimism',
		slug: 'optimism',
		token: 'OP',
	},
	particle_chain: {
		id: 'particle_chain',
		name: 'Particle',
		slug: 'particle',
		soon: true,
		token: 'PARTI',
	},
	peaq_chain: {
		id: 'peaq_chain',
		name: 'peaq',
		slug: 'peaq',
		soon: true,
		token: 'PEAQ',
	},
	pendulum_chain: {
		id: 'pendulum_chain',
		name: 'Pendulum',
		slug: 'pendulum',
		soon: true,
		token: 'PEN',
	},
	phala_chain: {
		id: 'phala_chain',
		name: 'Phala Network',
		slug: 'phala',
		soon: true,
		token: 'PHA',
	},
	polkadex_chain: {
		id: 'polkadex_chain',
		name: 'Polkadex',
		slug: 'polkadex',
		token: 'PDEX',
	},
	polkadot_relay_chain: {
		id: 'polkadot_relay_chain',
		name: 'Polkadot',
		slug: 'polkadot',
		token: 'DOT',
	},
	polygon_chain: {
		id: 'polygon_chain',
		name: 'Polygon',
		slug: 'polygon',
		token: 'MATIC',
	},
	quai_chain: {
		id: 'quai_chain',
		name: 'Quai Network',
		slug: 'quai',
		soon: true,
		token: 'QUAI',
	},
	qubic_chain: {
		id: 'qubic_chain',
		name: 'Qubic',
		slug: 'qubic',
		soon: true,
		token: 'QUBIC',
	},
	radix_chain: {
		id: 'radix_chain',
		name: 'Radix',
		slug: 'radix',
		soon: true,
		token: 'XRD',
	},
	redbelly_chain: {
		id: 'redbelly_chain',
		listed: new Date('2025-03-26T00:00:00Z'),
		name: 'Redbelly',
		slug: 'redbelly',
		token: 'RBNT',
	},
	reddio_chain: {
		id: 'reddio_chain',
		name: 'Reddio',
		slug: 'reddio',
		soon: true,
	},
	robonomics_chain: {
		id: 'robonomics_chain',
		name: 'Robonomics',
		slug: 'robonomics',
		soon: true,
		token: 'XRT',
	},
	scroll_chain: {
		id: 'scroll_chain',
		name: 'Scroll',
		slug: 'scroll',
	},
	sei_chain: {
		id: 'sei_chain',
		name: 'Sei',
		slug: 'sei',
		token: 'SEI',
	},
	sirius_chain: {
		id: 'sirius_chain',
		name: 'Sirius',
		slug: 'sirius',
		token: 'XPX',
	},
	skale_chain: {
		id: 'skale_chain',
		name: 'Skale',
		slug: 'skale',
		soon: true,
		token: 'SKL',
	},
	solana_chain: {
		id: 'solana_chain',
		name: 'Solana',
		slug: 'solana',
		token: 'SOL',
	},
	somnia_chain: {
		id: 'somnia_chain',
		name: 'Somnia',
		slug: 'somnia',
		soon: true,
	},
	sonic_chain: {
		id: 'sonic_chain',
		listed: new Date('2025-01-08T00:00:00Z'),
		name: 'Sonic',
		slug: 'sonic',
		token: 'S',
	},
	starknet_chain: {
		id: 'starknet_chain',
		name: 'Starknet',
		slug: 'starknet',
		token: 'STRK',
	},
	stellar_chain: {
		id: 'stellar_chain',
		listed: new Date('2024-05-21T00:00:00Z'),
		name: 'Stellar',
		slug: 'stellar',
		token: 'XLM',
	},
	sui_chain: {
		id: 'sui_chain',
		name: 'Sui',
		slug: 'sui',
		soon: true,
		token: 'SUI',
	},
	supra_chain: {
		id: 'supra_chain',
		name: 'Supra',
		slug: 'supra',
		soon: true,
		token: 'SUPRA',
	},
	taraxa_chain: {
		id: 'taraxa_chain',
		listed: new Date('2024-12-23T00:00:00Z'),
		name: 'Taraxa',
		slug: 'taraxa',
		token: 'TARA',
	},
	tectum_chain: {
		id: 'tectum_chain',
		name: 'Tectum',
		slug: 'tectum',
		soon: true,
		token: 'TET',
	},
	telos_chain: {
		id: 'telos_chain',
		name: 'Telos',
		slug: 'telos',
		token: 'TLOS',
	},
	terra_chain: {
		id: 'terra_chain',
		name: 'Terra',
		slug: 'terra',
		soon: true,
		token: 'LUNA',
	},
	tezos_chain: {
		id: 'tezos_chain',
		name: 'Tezos',
		slug: 'tezos',
		soon: true,
		token: 'XTZ',
	},
	ton_chain: {
		id: 'ton_chain',
		name: 'Ton',
		slug: 'ton',
		soon: true,
		token: 'TON',
	},
	tron_chain: {
		id: 'tron_chain',
		name: 'Tron',
		slug: 'tron',
		token: 'TRX',
	},
	u2u_chain: {
		id: 'u2u_chain',
		name: 'U2U Network',
		slug: 'u2u-network',
		soon: true,
		token: 'U2U',
	},
	unichain_chain: {
		id: 'unichain_chain',
		name: 'Unichain',
		slug: 'unichain',
		soon: true,
	},
	vechain_chain: {
		id: 'vechain_chain',
		name: 'VeChain',
		slug: 'vechain',
		soon: true,
		token: 'VET',
	},
	wanchain_chain: {
		id: 'wanchain_chain',
		listed: new Date('2024-04-07T00:00:00Z'),
		name: 'Wanchain',
		slug: 'wanchain',
		token: 'WAN',
	},
	waterfall_chain: {
		id: 'waterfall_chain',
		name: 'Waterfall',
		slug: 'waterfall',
		token: 'WATER',
	},
	xelis_chain: {
		id: 'xelis_chain',
		name: 'Xelis',
		slug: 'xelis',
		soon: true,
		token: 'XEL',
	},
	xrpl_chain: {
		id: 'xrpl_chain',
		name: 'XRP Ledger',
		slug: 'xrpl',
		soon: true,
		token: 'XRP',
	},
	xx_chain: {
		id: 'xx_chain',
		listed: new Date('2024-06-14T00:00:00Z'),
		name: 'xx network',
		slug: 'xx-network',
		token: 'XX',
	},
	zeitgeist_chain: {
		id: 'zeitgeist_chain',
		name: 'Zeitgeist',
		slug: 'zeitgeist',
		token: 'ZTG',
	},
}

export const CHAINS_CONFIG_BY_SLUG = Object.fromEntries(
	Object.entries(CHAINS_CONFIG).map(([, val]) => [val.slug, val])
)

export const CHAINS_LIST = Object.values(CHAINS_CONFIG).sort((a, b) => {
	const aLower = a.name.toLowerCase()
	const bLower = b.name.toLowerCase()

	if (aLower < bLower) {
		return -1
	}

	if (aLower > bLower) {
		return 1
	}

	return 0
})

export const LISTED_CHAINS = CHAINS_LIST.filter(chainConfig => chainConfig?.soon !== true)

export const AMOUNT_OF_DAYS_FOR_NEW_LABEL = 90
